import { useEffect, useState } from "react";
import client from "@/lib/api";

export function useActionCategories() {
  const [cats, setCats] = useState({ types: [], subtypes: [] });
  useEffect(() => {
    client.get("/action-categories").then(({ data }) => setCats(data)).catch(() => {});
  }, []);
  return cats;
}
